import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const DiscountValue = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "span",
  color: "fill-positive-default",
  typography: "heading-25",
  children: children
});
const RecurringDiscountMessage = ({
  discount,
  hasFutureCharges
}) => {
  if (!hasFutureCharges || !(discount !== null && discount !== void 0 && discount.discountCode) || discount.durationType !== 'RECURRING' || discount.valueType !== 'PERCENT') {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payments.futureCharges.recurringDiscountApplied_jsx",
      options: {
        discountCode: discount.discountCode,
        discountValue: `${discount.value}%`
      },
      elements: {
        DiscountValue
      }
    })
  });
};
export default RecurringDiscountMessage;